import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { NavigationRoute } from 'src/app/core/constants/constants';
import { RegBlobDataTypeEnum, RegWorkflowEnum } from 'src/app/core/dtos/enum';
import { Step } from 'src/app/core/dtos/step';
import { RegWorkflowMappingService } from 'src/app/core/services/reg-workflow-mapping.service';
import { PageStepEnum, StepProgressService } from 'src/app/core/services/step-progress.service';
import { selectRegTestSession } from 'src/app/state/reg-data.selectors';

@Component({
  selector: 'app-scanned-document-upload',
  templateUrl: './scanned-document-upload.component.html',
  styleUrls: ['./scanned-document-upload.component.scss']
})
export class ScannedDocumentUploadComponent implements OnInit, OnDestroy {

  pagePath = NavigationRoute.REGISTRATION.scannedDocumentUpload;
  regWorkFlow: RegWorkflowEnum;
  steps: Step[];
  firstFileUploaded = false;

  testSessionSubscription: Subscription;

  constructor(
    private stepProgressServiceService: StepProgressService,
    private regWorkflowMappingService: RegWorkflowMappingService,
    private router: Router,
    private store: Store,
  ) {
    this.steps = this.stepProgressServiceService.getSteps(PageStepEnum.ID);
  }

  public get RegBlobDataTypeEnum() {
    return RegBlobDataTypeEnum;
  }

  ngOnInit(): void {
    this.testSessionSubscription = this.store.pipe(select(selectRegTestSession))
      .subscribe(testSession => {
        this.regWorkFlow = this.regWorkflowMappingService.getRegWorkFlow(testSession);
      });
  }

  ngOnDestroy() {
    this.testSessionSubscription?.unsubscribe();
  }

  changeStatus() {
    this.firstFileUploaded = true;
  }

  redirectNextStep() {
    const nextStep = this.regWorkflowMappingService.getNextStepNew(this.regWorkFlow, this.pagePath);
    this.router.navigate([nextStep]);
  }

}
